import { invariant } from '@spotify/confidence-core-react';
import { StatsDataFragment } from '@spotify/confidence-graphql';
import {
  useIsStatsModuleStrategySequentialV2,
  useWorkflowInstanceContext,
} from '@spotify/plugin-confidence-workflows-react';

import { convertAnalysisResults } from '../helpers';
import { StatsData2 } from '../types';

export const useStatsData = (): StatsData2 => {
  const { isLive, moduleData2 } = useWorkflowInstanceContext();

  const statsData: StatsDataFragment | undefined | null = moduleData2?.stats;
  invariant(statsData, 'useStatsData: stats data is required');

  const isSequential = useIsStatsModuleStrategySequentialV2(statsData);
  const isFixedHorizon = !isSequential;

  return {
    analysisResults: convertAnalysisResults(statsData.analysisResults),
    isSequential,
    isFixedHorizon,
    canHaveResults: !isFixedHorizon || !isLive,
  };
};
